'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            backgroundColor: theme.background,
            padding: theme.padding,
            borderRadius: theme.borderRadius,
            display: 'inline-block',

            '& .qr-colored': {
                backgroundColor: theme.pixelBackground
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        background: theme.elPrimary,
        pixelBackground: theme.tFilled,
        borderRadius: '3px',
        padding: theme.gutter + 'px'
    };
};